import React, { Fragment } from "react";
import Section from "../../utility/ui-components/section";
import Container from "../../utility/ui-components/container";
import InnerBannerSection from "../../utility/ui-components/innerPageBanner";
import ProductData from "../../../common/assets/data/products";
import ProductContentSections from "./productContentSections";
import PricingSection from "./pricingSections";
import ChannelPartnerSection from "../../utility/ui-components/channelPatner";
import { useLocation } from "react-router-dom";
function Services() {
  const location = useLocation();
  window.scrollTo(0 , 0);
  const content = ProductData.filter((item) => {
    return item.path === location.pathname;
  });
  let data = content[0]?.pageContent;
  return (
    <Fragment>
      <InnerBannerSection content={data.PageBanner} />
      <ProductContentSections content={data.MiddleContent} />
      {data.channelPartnerSection && (
      <ChannelPartnerSection content={data.channelPartnerSection}/>)}
      {/* <PricingSection content={data.PricingSection} /> */}
  
    </Fragment>
  );
}

export default Services;
